import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { ReadOnlyTypography } from '@warehouse/shared/ui';
import TitleEditableField from '../../TitleEditableField';
import TextInput from '../../../library/TextInput';

interface HouseSequenceNumberFieldProps {
	houseSequenceNumber: string;
	setHouseSequenceNumber: (houseSequenceNumber: string) => void;
	isInherited: boolean;
	onBlur: () => void;
}

function HouseSequenceNumberField({
	houseSequenceNumber,
	setHouseSequenceNumber,
	isInherited,
	onBlur,
}: HouseSequenceNumberFieldProps) {
	return useMemo(
		() => (
			<TitleEditableField
				label="House Sequence:"
				path={titlePaths.houseSequence}
				jumpToParentButtonDisabled
				tooltipDisabled
				readComponent={
					<ReadOnlyTypography variant={isInherited ? 'prefilled' : 'default'}>{houseSequenceNumber}</ReadOnlyTypography>
				}
				editComponent={
					<TextInput
						fullWidth
						variant={isInherited ? 'prefilled' : 'default'}
						value={houseSequenceNumber}
						onChange={(e) => setHouseSequenceNumber(e.target.value)}
						onBlur={onBlur}
						height={38}
						width="50%"
					/>
				}
			/>
		),
		[houseSequenceNumber, isInherited],
	);
}

export default HouseSequenceNumberField;
